import React , {useState} from 'react'
import Button from './Button';
import { AiOutlineArrowRight } from '@react-icons/all-files/ai/AiOutlineArrowRight';
const SalesValues = ({potential, setStep, values}) => {
    let [part, setPart] = useState(0)






  return <div className='sSlide'>

    <div className='row'>
        <div className='slideCard'>
            <div className='cardTitle'>
                Our Philosophy
            </div>
            <div className='cardBody'>
                {Object.keys(values).filter(v => potential?.metrics?.values?.[v]).map((v,i) => <div key={i} className={`col ${i ===1 ? 'center' :''}`}>
                    <strong>{values[v][0]}</strong>
                    <p>{values[v][1]}</p>
                </div>)}
                </div>
            </div>

        </div>




    <div className='buttons'>
        <Button className='btn-5  highLight' onClick={() => setStep(1)} ><AiOutlineArrowRight />Continue</Button>
    </div>

  </div>
}

export default SalesValues